/** @format */
import {
	Component,
	ComponentRef,
	DestroyRef,
	OnDestroy,
	OnInit,
	TemplateRef,
	inject,
	viewChild
} from '@angular/core';
import {
	HmfModalComponent,
	HmfModalFactoryService,
	HmfProductCardComponent
} from '@dsg-tech/homefield-angular';
import {
	MediaSourceEnum,
	ObjectFitEnum
} from '../../../../../product-reviews/components/src/lib/models';
import {
	SocialImagesReviewMedia,
	closeSocialContentModal,
	selectProductSocialCarouselIndex,
	selectProductSocialContentItems,
	selectProductSocialContentModal
} from '@social-content/data-access';

import { CommonModule } from '@angular/common';
import { HomefieldIconLibraryModule } from '@dsg-tech/homefield-angular-icons';
import { ReviewMediaComponent } from '@product-reviews/components/review-media';
import { Store } from '@ngrx/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'product-reviews-social-images-modal',
	imports: [
		CommonModule,
		HmfProductCardComponent,
		HomefieldIconLibraryModule,
		ReviewMediaComponent
	],
	templateUrl: './review-social-images-modal.component.html',
	styleUrl: './review-social-images-modal.component.scss'
})
export class ReviewSocialImagesModalComponent implements OnInit, OnDestroy {
	private modalRef: ComponentRef<HmfModalComponent>;
	modalOpened = false;

	readonly modalContent = viewChild.required<TemplateRef<unknown>>('modalContent');
	private readonly modalFactoryService = inject(HmfModalFactoryService);
	private readonly store = inject(Store);
	private readonly destroyRef = inject(DestroyRef);

	mediaItems: SocialImagesReviewMedia[] = [];
	mediaIndex = 0;

	MediaSourceEnum = MediaSourceEnum;
	ObjectFitEnum = ObjectFitEnum;

	ngOnInit() {
		this.store
			.select(selectProductSocialContentItems)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((contentItems) => {
				this.mediaItems = contentItems.map((item, index) => ({
					id: index.toString(),
					photo: {
						Caption: null,
						Id: index.toString(),
						Sizes: {
							large: {
								Id: '',
								Url: item.media.large
							},
							normal: {
								Id: '',
								Url: item.media.medium
							},
							thumbnail: {
								Id: '',
								Url: item.media.small
							}
						},
						SizesOrder: ['large', 'normal', 'thumbnail']
					},
					url: item.media.extraLarge,
					products: item.products.map((product) => ({
						id: product.id,
						assetSeoUrl: product.link,
						ecode: product.metadata.productId,
						pricing: {
							prices: {
								maxListPrice: product?.price?.display,
								maxOfferPrice: product?.price?.display,
								minListPrice: product?.price?.display,
								minOfferPrice: product?.price?.display
							},
							isHidden: !product?.price?.display
						},
						productName: product.name,
						imageData: {
							imageUrl: `${product.images[0].mediumSquare}?1=1`,
							width: '124',
							height: '124'
						}
					})),
					likeCount: item.metadata?.likeCount || 0
				}));

				this.listenIndexChange();
			});

		this.store
			.select(selectProductSocialContentModal)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((openModal) => {
				if (openModal) {
					this.openModal();
				}
			});
	}

	listenIndexChange() {
		this.store
			.select(selectProductSocialCarouselIndex)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((index) => {
				if (index > -1 && index < this.mediaItems.length) {
					this.mediaIndex = index;
				}
			});
	}

	closeModalEvt() {
		this.store.dispatch(closeSocialContentModal());
		this.modalOpened = false;
	}

	openModal() {
		if (this.modalOpened) {
			return;
		}

		if (!this.modalRef) {
			this.modalRef = this.modalFactoryService.create(
				HmfModalComponent,
				{
					className: 'review-social-images-modal',
					clickableBackground: true,
					isCloseButtonSticky: true,
					focus: true,
					headerText: '@dickssportinggoods',
					showHeaderBottomBorder: false
				},
				this.modalContent()
			);

			this.modalRef.instance.closed.subscribe(() => this.closeModalEvt());
		}

		this.modalRef.instance.openModal();
		this.modalOpened = true;
	}

	previousSlide() {
		if (this.mediaIndex > 0) {
			this.mediaIndex--;
		}
	}

	nextSlide() {
		if (this.mediaIndex < this.mediaItems.length - 1) {
			this.mediaIndex++;
		}
	}

	goToProduct(product) {
		window.location = product.assetSeoUrl;
	}

	selectedMediaClick() {
		this.nextSlide();
	}

	ngOnDestroy() {
		if (this.modalRef) {
			this.modalRef?.destroy();
		}
	}
}
